export function endsInS(string: string): boolean {
  return string[string.length - 1].toLowerCase() === 's'
}
